<template>
  <div id="app">
    <TodoHeader></TodoHeader>
    <router-view></router-view>
  </div>
</template>

<script>
  import TodoHeader from './components/TodoHeader.vue'

  export default{
    components:{
      'TodoHeader': TodoHeader
    }
  }
</script>
<style>
  body {
    text-align: center;
    background-color: #F6F6F8;
  }
  input {
    border-style: groove;
    width: 200px;
  }
  button {
    border-style: groove;
  }
  .shadow {
    box-shadow: 5px 10px 10px rgba(0, 0, 0, 0.03)
  }
</style>



// WEBPACK FOOTER //
// src/App.vue